module.exports = __webpack_public_path__ + "7da6ab9ac7e5ca6d693446143a3ee83e.svg";